import { FunctionComponent } from 'react';
import MoneyBillWaveSolidIcon from '../../../../../../Icons/MoneyBillWaveSolidIcon';
import styles from './styles.module.scss';
import ButtonLink from '../../../../../../ButtonLink';
import { PaymentMethod } from '@shared/types';

type ConfirmationDetailsCardProps = {
    orderId?: string;
    orderPaymentMethod?: PaymentMethod;
};

export const PayInvoiceButton: FunctionComponent<ConfirmationDetailsCardProps> = ({
    orderId,
    orderPaymentMethod,
}) => {
    if (orderPaymentMethod !== 'invoice') {
        return null;
    }

    return (
        <ButtonLink
            href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/complete-order/${orderId}`}
            target="_blank"
            rel="noopener noreferrer"
            preset="primary"
            className={styles.button}
        >
            <MoneyBillWaveSolidIcon />
            Pay Invoice
        </ButtonLink>
    );
};
